<div class="wrapper">
  <div class="alert-img"></div>
  <div class="text">توجه داشته باشید که با حذف کارت بانکی، تراکنش پرتکرار متصل به آن نیز حذف می‌شود.</div>

  <div
    class="show-recommendation"
    [class.one-recommendation]="recommendations.length === 1"
  >
    <c2c-applet-recommendation-item
      class="item"
      *ngFor="let i of recommendations"
      [item]="i"
      [showMoreAction]="false"
      [clickable]="false"
    ></c2c-applet-recommendation-item>
  </div>
</div>
<div class="actions">
  <common-ui-components-temp-ngx-button
    class="cancel-button"
    [style]="'tinted-on-elevated'"
    (clickHandler)="cancel()"
  >
    انصراف
  </common-ui-components-temp-ngx-button>
  <common-ui-components-temp-ngx-button
    class="save-button"
    [fullWidth]="true"
    (clickHandler)="save()"
  >
    ادامه و حذف کارت
  </common-ui-components-temp-ngx-button>
</div>
